import { setShowBalances } from "@/modules/dashboard/state";
import type { IDeposit } from "@/modules/deposit/common/types";
import { useGetDepositsQuery } from "@/modules/deposit/services";
import { AppPaths } from "@/shared/common/enums";
import type { IError } from "@/shared/common/types";
import { PageWidgetTemplate } from "@/shared/components";
import { useAppDispatch, useShowBalance } from "@/shared/hooks";
import { setActiveDepositId } from "@/shared/state/common";
import classNames from "classnames";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { DepositsItem } from "./DepositsItem";

interface Props {
  depositId?: string | number;
  limit?: number;
}

export const Deposits = ({
  depositId,
  limit,
}: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { handleShowBalances } = useShowBalance();
  const {
    data: deposits,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetDepositsQuery({
    pageSize: limit,
  }, {
    refetchOnMountOrArgChange: true,
  });

  const onShowDetails = (deposit: IDeposit) => {
    dispatch(setActiveDepositId(deposit.id));
    if (!location.pathname.includes(AppPaths.Deposits)) {
      navigate(AppPaths.Deposits);
    }
  };

  useEffect(() => {
    if (deposits?.length) {
      const showBalances = Array(deposits.length).fill(false);
      dispatch(setShowBalances(showBalances));
    }
  }, [deposits]);

  return (
    <PageWidgetTemplate
      isFetching={isFetching}
      isError={isError}
      error={error as IError}
      refetch={refetch}
      isEmpty={!deposits?.length}
    >
      {deposits?.map((deposit, i) => (
        <div
          className="full-width"
          key={deposit.contractNumber}
          onClick={() => onShowDetails(deposit)}
        >
          <DepositsItem
            {...deposit}
            index={i}
            handleShowBalances={handleShowBalances}
            className={classNames({ "selected": depositId === deposit.id })}
          />
        </div>
      ))}
    </PageWidgetTemplate>
  );
};
